import { render, staticRenderFns } from "./DeleteSupplier.vue?vue&type=template&id=1ffa6125&scoped=true"
import script from "./DeleteSupplier.vue?vue&type=script&lang=js"
export * from "./DeleteSupplier.vue?vue&type=script&lang=js"
import style0 from "./DeleteSupplier.vue?vue&type=style&index=0&id=1ffa6125&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffa6125",
  null
  
)

export default component.exports